import React from 'react';
import { Check } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
import { cn } from '../lib/utils';

/** Estado intermedio de revisión: el statement ya fue revisado por la contadora
 *  pero todavía NO se aprobó (el status real sigue siendo pending_review). */
export default function ReviewedBadge({ className, testid = 'reviewed-badge' }) {
  const { t } = useLang();
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full text-[11px] font-semibold whitespace-nowrap',
        className
      )}
      style={{
        color: 'var(--success-fg)',
        background: 'var(--success-bg)',
        border: '1px solid var(--success-border)',
        padding: '4px 10px',
      }}
      data-testid={testid}
    >
      <Check className="h-3 w-3" />
      <span>{t('deposits.reviewed_badge')}</span>
    </span>
  );
}
